
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/skikart",
      function () {
        return require("private-next-pages/[region]/[resort]/skikart.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/skikart"])
      });
    }
  